import React, { useEffect } from 'react'
import { TextField, Grid, Box, Button } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { FreeRideThreeSchema } from '../../Utils/Validations'
const RideFormThree = ({ handleBack, handleComplete, freeRideData, setFreeRideData }) => {
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(FreeRideThreeSchema)
  })
  useEffect(() => {
    setValue("patient_relation", freeRideData.patient_relation || "")
    setValue("patient_age", freeRideData.patient_age || "")
  }, [])
  const onSubmit = (data) => {
    console.log(data)
    setFreeRideData((prev) => ({ ...prev, patient_relation: data.patient_relation, patient_age: data.patient_age }))
    handleComplete()
  }


  return (
    <div>

      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }} >
          <Controller
            control={control}
            name="patient_relation"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>Relationship to Patient</label>
                <TextField fullWidth placeholder="Relationship to Patient" {...field} error={errors.patient_relation} helperText={errors?.patient_relation?.message} />
               
              </>
            )}
          />


        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, marginTop: { sm: 0, xs: 2 } }} >
          <Controller
            control={control}
            name="patient_age"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>Patient's Age</label>
                <TextField fullWidth placeholder="Patient's Age" {...field} error={errors.patient_age} helperText={errors?.patient_age?.message} />
                
              </>
            )}
          />

        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default RideFormThree